module.exports = __webpack_public_path__ + "static/media/Brightly_ios_3.58394148.jpg";